export default __webpack_public_path__ + "static/media/group-logo-1.2c651996.png";